export const API_JSON_CONTENT_TYPE = 'application/vnd.api+json';

/** Header for domain entity type (CACT capability endpoints). */
export const CONFIG_ENTITY_TYPE_HEADER_NAME = 'X-League-Config-Entity-Type';

/** Header for action (CACT capability endpoints). */
export const CONFIG_ENTITY_ACTION_HEADER_NAME = 'X-League-Config-Entity-Action';
